import moment from "moment";
const state = {
    count: 0,
    firstName: '姓张',
    lastName: '名许',
    student: ['张三', '李四', '王二'],
    time: moment(new Date()).format("YYYY-MM-DD")
  }
export default state




// WEBPACK FOOTER //
// ./src/store/state.js